import React from 'react';

const FUNNEL_COLORS = ['#6366f1', '#818cf8', '#a5b4fc', '#c7d2fe', '#e0e7ff'];

const FunnelChart = ({ title, steps, loading }) => {
  if (loading) {
    return (
      <div className="bi-chart-card">
        {title && <h3 className="bi-chart-title">{title}</h3>}
        <div className="bi-chart-skeleton" style={{ height: 160 }} />
      </div>
    );
  }

  if (!steps || steps.length === 0) {
    return (
      <div className="bi-chart-card">
        {title && <h3 className="bi-chart-title">{title}</h3>}
        <div className="bi-chart-empty" style={{ height: 120 }}>No funnel data</div>
      </div>
    );
  }

  const maxCount = steps[0]?.count || 1;

  return (
    <div className="bi-chart-card">
      {title && <h3 className="bi-chart-title">{title}</h3>}
      <div className="bi-funnel">
        {steps.map((step, i) => {
          const pct = maxCount > 0 ? (step.count / maxCount) * 100 : 0;
          const conversionFromPrev = i > 0 && steps[i - 1].count > 0
            ? ((step.count / steps[i - 1].count) * 100).toFixed(1)
            : null;

          return (
            <div key={i} className="bi-funnel-step">
              <div className="bi-funnel-label">{step.label}</div>
              <div className="bi-funnel-bar-track">
                <div
                  className="bi-funnel-bar-fill"
                  style={{
                    width: `${Math.max(pct, 2)}%`,
                    backgroundColor: FUNNEL_COLORS[i % FUNNEL_COLORS.length],
                  }}
                />
              </div>
              <div className="bi-funnel-stats">
                {step.count.toLocaleString()}
                {conversionFromPrev && (
                  <span style={{ color: 'var(--admin-gray-400)', marginLeft: 4 }}>
                    ({conversionFromPrev}%)
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FunnelChart;
